import { render, staticRenderFns } from "./SplitterModalTransferBase.vue?vue&type=template&id=3d24a2a2"
import script from "./SplitterModalTransferBase.vue?vue&type=script&lang=js"
export * from "./SplitterModalTransferBase.vue?vue&type=script&lang=js"
import style0 from "./SplitterModalTransferBase.vue?vue&type=style&index=0&id=3d24a2a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports